import moment from "moment"
import React, { useEffect, useState } from "react"
import Send from "../../core/communication"
import BurnedScreen from "../../screen/BurnedScreen"
import { useScope } from "../SelectProjectCompanyContainer"
import { SubheaderFilter } from "../../components/Subheader"
import { useFilter } from "../../core/utils/hooks/useFilter"

const geovale = require("./geo-vale.json")

const BurnedContainer = ({onlyMap = false, userInfo}) => {
  const { scope, scopeType } = useScope()
  const [valuesToSearch, onChange, reload, onReload] = useFilter('geo-period-filter');
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [points, setPoints] = useState([])

  const loadData = async (projects) => {
    let newProjects = [...projects];
    const formattedDate =
      startDate && startDate !== "Data inválida"
        ? `&startDate='${startDate}'&endDate='${endDate}'`
        : ""

    const focus = Send.get("/DW/burnedFocus", `${formattedDate}`)
    const users = Send.get(`/projects/users/${scope?.id}`, `scopeType=${scopeType}`)
    const dw = Send.get("/dw/data", `projects='${scope?.id}'&code='GPS'&scopeType=${scopeType}`)

    const groupedProjects = ['Ambev', 'SEMPROR', 'Vale', 'CUIA'];

    newProjects = newProjects
      .filter((item) => item?.value)
      .map((project) => (!groupedProjects.includes(project.label) ? `${project?.value}`.replaceAll("'", '') : `${project?.value}`.replaceAll("'", '')))
      .toString()
      .split(',')

      let [usersData, focusData, dwData] = await Promise.all([users, focus, dw])
      
      dwData = dwData.concat(geovale.filter(item => newProjects.includes(item.project)).map(item => ({
        ...item,
        Produtor: item.id,
        Resposta: `${item.latitude}|${item.longitude}`
      })))
      
    const userDw = dwData
      .map((item) => {
        const geo = item && item.Resposta && `${item.Resposta}`.split("|")
        const user = usersData.find((data) => data.user && data.user.id === item.Produtor)?.user

        if (geo && geo.length > 1) {
          return {
            id: item.Produtor,
            name: user?.name || item.name,
            positionProducer: {
              lat: parseFloat(geo[0]),
              lng: parseFloat(geo[1]),
            },
          }
        }
      })
      .filter((item) => item)

    setPoints(
      userDw
        .filter((item) => userInfo?.id ? item.id === userInfo.id : true)
        .map((user) => {
          const focus = focusData?.find((focus) => focus.ID_Produtor === user.id)

          const focusObj = {
            id: focus?.ID_Produtor || user.id,
            nameCity: focus?.Municipio_Foco,
            nameProducer: focus?.Nome_Produtor || user.name,
            positionProducer: {
              lat: focus?.Latitude_Produtor,
              lng: focus?.Longitude_Produtor,
            },
            positionFocus: {
              lat: parseFloat(focus?.Latitude_Foco),
              lng: parseFloat(focus?.Longitude_Foco),
            },
            distanceFocus: parseFloat(focus?.Distancia_Foco).toFixed(0) || null,
            dateFocus:
              focus?.Data_Queimada.value || moment().subtract(1, "days").format("YYYY-MM-DD"),
            circle: {
              radius: 5000,
              options: {
                strokeColor: "#ff0000",
                strokeWeight: 1,
                fillOpacity: 0.2,
              },
            },
          }

          return {
            ...focusObj,
            ...user,
            positionProducer:
              focusObj.positionProducer.lat && focusObj.positionProducer.lng
                ? focusObj.positionProducer
                : user.positionProducer,
          }
        })
        .filter((item) => item),
    )

    setLoading(false)
  }

  useEffect(() => {

      loadData( userInfo?.id ? [{ label: userInfo.project, value: userInfo.projectId}] : [{ label: scope.description, value: scope.id}] )

  }, [startDate, endDate, reload, userInfo, scope?.id])
  
  return (
    <> 
    {
      !onlyMap &&
      <SubheaderFilter {...{
          setLoading,
          loading,
          isJourney: false,
          dateType: 1,
          periodReference: false,
          keyFilter: 'geo-period-filter'
        }} />
    } 
      <BurnedScreen 
        {...{
          setStartDate,
          startDate,
          endDate,
          setEndDate,
          points,
          onlyMap
        }}
      />
    </>
  )
}

export default BurnedContainer
